"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/FormFieldFromProps"));
const Button_1 = require("@Components/Buttons/Button");
const ExpandableItem_1 = __importDefault(require("@App/kit/components/Navigations/Sidebar/ExpandableItem"));
const clsx_1 = __importDefault(require("clsx"));
require("./index.scss");
/**
 * @template K - The record type for the "filter" portion of the form
 */
const FilterSection = (props) => {
    const { filterCollections, handleFilterValueChange, onApplyFilter, onResetFilter } = props;
    const { watch, resetField } = (0, react_hook_form_1.useFormContext)();
    const filterEntries = (0, react_1.useMemo)(() => filterCollections.map((collection, i) => ({
        name: collection.name,
        allowMultiple: collection.allowMultiple,
        filterFields: collection.filterFields.flatMap((filterField) => Object.entries(filterField)),
    })), [filterCollections]);
    const onFilterReset = () => {
        if (filterEntries) {
            // Neat, I had to double-disable linting for these - it's having trouble detecting the field names on the generic
            // for whatever reason - this *does* work to reset the 'filter' fields while preserving the 'search' fields.
            filterEntries.forEach((value) => value.filterFields.forEach((field) => {
                if (field[1].name !== 'sort_by') {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    resetField(`filter.${field[1].name}`);
                }
            }));
        }
        onResetFilter && onResetFilter();
    };
    // When the FilterSection changes, it receives the *full* form, not just the filter.  This works around that limitation
    const onFilterChange = (filter) => {
        handleFilterValueChange && handleFilterValueChange(filter);
    };
    // Update Inputs When They Change
    (0, react_1.useEffect)(() => {
        const subscription = watch((value) => onFilterChange(value.filter));
        return () => subscription.unsubscribe();
    }, [watch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'filter-section' },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('filter-options') },
                react_1.default.createElement("h3", null, "Filter"),
                react_1.default.createElement("div", { className: 'filter-fields-section' }, filterEntries.map((filterEntry) => (react_1.default.createElement(ExpandableItem_1.default, { key: filterEntry.name, heading: filterEntry.name, className: (0, clsx_1.default)(!filterEntry.allowMultiple && 'multi-filter') }, filterEntry.filterFields.map((filterCollectionEntry) => (react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, filterCollectionEntry[1], { name: `filter.${filterCollectionEntry[1].name}`, key: filterCollectionEntry[0] })))))))))),
        react_1.default.createElement("div", { className: 'button-container' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onFilterReset, submitType: 'button' }, "Remove Filters"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => onApplyFilter && onApplyFilter(false), submitType: 'button' }, "Apply Filters"))));
};
exports.default = FilterSection;
